import { hasQueryStringParameter } from 'owa-querystring';

const MINI_NATIVE_QUERY_STRING = 'miniNative';

export const isNative = (): boolean => hasQueryStringParameter(MINI_NATIVE_QUERY_STRING);
